export const FETCH_DASHBOARD_DETAILS   = "FETCH_DASHBOARD_DETAILS"
export const FETCH_ONBOARD_PROCESS_STATICS  =   "FETCH_ONBOARD_PROCESS_STATICS"
